import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const WarningNoFill = ({
  height = 16,
  width = 16,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.15958 2.68851C6.97747 1.27184 9.02289 1.27184 9.84079 2.68851L14.7436 11.1874C15.5604 12.6039 14.538 14.374 12.9035 14.374H3.09685C1.46204 14.374 0.438992 12.6042 1.25681 11.1874L6.15958 2.68851ZM7.24212 3.3135L2.33956 11.812C2.0029 12.3951 2.42373 13.124 3.09685 13.124H12.9035C13.5757 13.124 13.9972 12.3955 13.6608 11.812M13.6608 11.812L8.75825 3.3135C8.42144 2.73042 7.57893 2.73042 7.24212 3.3135M8.00018 6.12401C8.34536 6.12401 8.62518 6.40383 8.62518 6.74901V9.24901C8.62518 9.59419 8.34536 9.87401 8.00018 9.87401C7.65501 9.87401 7.37518 9.59419 7.37518 9.24901V6.74901C7.37518 6.40383 7.65501 6.12401 8.00018 6.12401ZM7.37518 11.249C7.37518 10.9038 7.65501 10.624 8.00018 10.624H8.00485C8.35003 10.624 8.62985 10.9038 8.62985 11.249V11.2543C8.62985 11.5995 8.35003 11.8793 8.00485 11.8793H8.00018C7.65501 11.8793 7.37518 11.5995 7.37518 11.2543V11.249Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
